<template>
  <v-layout
    column
    :class="css"
  >
    <v-menu
      v-model="datefieldShowCalendarDialog"
      lazy
      :min-width="mobileDatepickerMinWidth"
    >
      <v-text-field
        slot="activator"
        :label="noLabel ? '' : field.data.label"
        :value="value"
        :placeholder="field.data.placeholder"
        :prepend-icon="buttonIcon"
        :required="field.required"
        :rules="field.rules"
        :clearable="
          field.data.clearable !== undefined ? field.data.clearable : true
        "
        clear-icon="add_circle"
        class="rotate-clear-icon-to-look mt-0"
        readonly
        @click:clear="onDateChanged('')"
      />
      <v-date-picker
        :input="value"
        color="msr"
        no-title
        scrollable
        event-color="msr"
        :first-day-of-week="1"
        :locale="$t('_datepickerLocale')"
        @change="onDateChanged"
      />
    </v-menu>
  </v-layout>
</template>

<script>
import dayjs from 'dayjs';

import {OverlayOptionsField} from '@/mixins/overlayOptions.js';
import mobileDatepickerMinWidth from '@/mixins/mobileDatepickerMinWidth.js';

export default {
  mixins: [mobileDatepickerMinWidth],
  props: {
    field: {
      type: OverlayOptionsField,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    backgroundClass: {
      type: String,
      default: 'overlay-options-field-bg',
    },
    marginClass: {
      type: String,
      default: 'mb-3',
    },
    buttonIcon: {
      type: String,
      default: 'calendar_today',
    },
    dateFormat: {
      type: String,
      default: 'DD.MM.YYYY',
    },
  },
  data() {
    return {
      datefieldShowCalendarDialog: false,
    };
  },
  computed: {
    css() {
      const classNames = [];
      if (this.backgroundClass) {
        classNames.push(this.backgroundClass);
      }
      if (this.marginClass) {
        classNames.push(this.marginClass);
      }
      if (!this.smallInlineButton) {
        classNames.push('pt-3 px-3 pb-2');
      }
      return classNames;
    },
  },
  methods: {
    onDateChanged(value) {
      let formattedDate = value;
      if (!!value) {
        formattedDate = dayjs(value).format(this.dateFormat);
      }
      this.$emit('update:value', formattedDate);
    },
  },
};
</script>

<style scoped>
.rotate-clear-icon-to-look >>> .v-input__icon--clear {
  transform: rotateZ(45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/OverlayDataDateField.vue